module.exports = "<p>\r\n  denials-audits works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/providers-billing/denials-audits/denials-audits.component.html
// module id = 2491
// module chunks = 66